import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { displayValue } from 'utils/valueFormatting/display.utils';

export const sunDetails = [
  {
    id: 'sunrise',
    label: 'Sunrise',
    iconKey: WEATHER_DETAIL_ICON_KEYS.SUNRISE,
    getValue: (astronomy) => displayValue(astronomy?.sunrise),
  },
  {
    id: 'sunset',
    label: 'Sunset',
    iconKey: WEATHER_DETAIL_ICON_KEYS.SUNSET,
    getValue: (astronomy) => displayValue(astronomy?.sunset),
  },
];

export const moonDetails = [
  {
    id: 'moonrise',
    label: 'Moonrise',
    iconKey: WEATHER_DETAIL_ICON_KEYS.MOONRISE,
    getValue: (astronomy) => displayValue(astronomy?.moonrise),
  },
  {
    id: 'moonset',
    label: 'Moonset',
    iconKey: WEATHER_DETAIL_ICON_KEYS.MOONSET,
    getValue: (astronomy) => displayValue(astronomy?.moonset),
  },
];
